import React, { useState, useEffect, useMemo } from 'react';
import ReactTable from '../../components/custom/ReactTable';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import { useHistory } from "react-router-dom";
import { UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { navigateTo, createMultiPartFormBody } from "../../util/Util";
import NavigationButton from '../../components/custom/NavigationButton';
import { ApiKey, WebUrl, ApiUrl, AccessRight, AlertTypes, DataName, SystemMessageType } from "../../util/Constant";
import { checkIfPermissionExist } from "../../util/PermissionChecker";
import { useTranslation } from 'react-i18next';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { showResponseMessage, showMessage } from "../../redux/AppAction";
import ApiEngine from '../../util/ApiEngine.js';

/// <summary>
/// Author : Yong Sheng Chuan
/// </summary>
const ManageQuickRemark = props => {
    const { t } = useTranslation();
    let _history = useHistory();
    const [messageData, setMessageData] = useState([]);
    var _dispatch = useDispatch();
    const _language = useSelector(state => state.appState.language);

    let _tableColumns = useMemo(() => [
        {
            Header: t("ACTION"),
            id: "action",
            Cell: ({ row }) => {
                return (<div className="btn-group m-r-5 m-b-5">
                    <UncontrolledButtonDropdown>
                        <DropdownToggle caret color="default"><i className="fas fa-cog"></i></DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => { navigateTo(_history, WebUrl._URL_QUICK_REMARK_DETAIL, row.original) }}><span>{t(checkIfPermissionExist(AccessRight._SYSTEM_SETTING_CONTROL_PERMISSION, true) ? "EDIT" : "VIEW")}</span></DropdownItem>
                            {checkIfPermissionExist(AccessRight._SYSTEM_SETTING_CONTROL_PERMISSION, true) && <DropdownItem onClick={() => deleteQuestion(row.original.id)}><span className="text-danger">{t("DELETE")}</span></DropdownItem>}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                </div>);
            },
            disableFilters: true,
            width: 100,
            style: { overflow: "visible" }
        },
        {
            Header: "QUESTION",
            accessor: "question",
            disableSortBy: true,
            disableFilters: true,
            minWidth: 300
        },
        {
            Header: t("ORDERING"),
            accessor: "ordering",
            disableSortBy: true,
            disableFilters: true,
            minWidth: 100
        },
        {
            Header: t("IS_COMPULSORY"),
            accessor: "isCompulsory",
            disableSortBy: true,
            disableFilters: true,
            Cell: ({ row }) => {
                return <span>{row.original.isCompulsory ? <span className="badge badge-secondary badge-green">{t("COMPULSORY")}</span> : <span className="badge badge-secondary badge-warning">{t("OPTIONAL")}</span>}</span>
            },
            minWidth: 100
        },
    ], [_language]);

    /// <summary>
    /// Author : Yong Sheng Chuan
    /// </summary>
    useEffect(() => {
        getMessage();
    }, []);

    /// <summary>
    /// Author : Yong Sheng Chuan
    /// </summary>
    async function getMessage() {
        var responseJson = await ApiEngine.get(ApiUrl._API_GET_DATA_LIST + "?type=" + DataName._SERVICE_QUICK_REMARK);
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setMessageData(responseJson[ApiKey._API_DATA_KEY]);
        }
    }

    /// <summary>
    /// Author : Yong Sheng Chuan
    /// </summary>
    async function setAnnouncementStatus(announcementId, isActive) {
        let params = {
            "isPublished": !isActive,
            "id": announcementId
        }

        var responseJson = await ApiEngine.post(ApiUrl._API_CREATE_OR_UPDATE + "?type=" + DataName._SERVICE_QUICK_REMARK, createMultiPartFormBody(params));

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            getMessage();
        }

        _dispatch(showMessage({
            type: responseJson[ApiKey._API_SUCCESS_KEY] ? AlertTypes._SUCCESS : AlertTypes._ERROR,
            content: t(responseJson[ApiKey._API_MESSAGE_KEY])
        }));
    }

    /// <summary>
    /// Author : Yong Sheng Chuan
    /// </summary>
    async function deleteQuestion(messageId) {
        let params = {
            "status": false,
            "id": messageId
        }

        var responseJson = await ApiEngine.post(ApiUrl._API_CREATE_OR_UPDATE + "?type=" + DataName._SERVICE_QUICK_REMARK, createMultiPartFormBody(params));

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            getMessage();
        }

        _dispatch(showMessage({
            type: responseJson[ApiKey._API_SUCCESS_KEY] ? AlertTypes._SUCCESS : AlertTypes._ERROR,
            content: t(responseJson[ApiKey._API_MESSAGE_KEY]),
        }));
    }

    return (
        <div>
            <div className="header-wrapper m-0 flex-lg-row flex-column align-items-start">
                <h1 className="page-header">{t("QUICK_REMARK")}</h1>
                {
                    checkIfPermissionExist(AccessRight._SYSTEM_SETTING_CONTROL_PERMISSION, true) &&
                    <NavigationButton history={_history} url={WebUrl._URL_QUICK_REMARK_DETAIL} buttonText={t("ADD_QUICK_REMARK")} />
                }
            </div>
            <Panel>
                <PanelBody>
                    <ReactTable data={messageData} columns={_tableColumns} filterable={true} />
                </PanelBody>
            </Panel>
        </div>
    );
}

export default ManageQuickRemark;